module.exports = require("react-redux");